const SEPARATOR = "\t";

function cleanTableCellTextToCopy(input) {
  try {
    if (input.trim() === "-") {
      return "0";
    }

    // Remove all commas and dollar signs
    let cleanedInput = input.replace(/[$,]/g, "");

    // Convert numbers in round brackets to negative numbers
    cleanedInput = cleanedInput.replace(
      /\((\d+(?:\.\d+)?)\)/g,
      (match, number) => `-${number}`
    );

    // Split the string into parts, separating numbers (including percentages) and text
    const parts = cleanedInput.split(/(-?\d+(?:\.\d+)?%?)/);
    const nonEmptyParts = parts.filter((part) => part.trim() !== "");

    // Count the number of numeric parts (including percentages and negative numbers)
    const numericPartsCount = nonEmptyParts.filter(
      (part) => !isNaN(parseFloat(part)) || part.endsWith("%")
    ).length;

    // Handle different cases based on the number of numeric parts
    if (
      numericPartsCount === 0 ||
      input.includes(")") ||
      input.includes("}") ||
      input.includes("]")
    ) {
      // No numbers, return original input
      return input;
    } else if (numericPartsCount === 1) {
      if (nonEmptyParts.length === 1) {
        // Only one number, no text
        return nonEmptyParts[0];
      } else {
        // One number and some text
        const numIndex = nonEmptyParts.findIndex(
          (part) => !isNaN(parseFloat(part)) || part.endsWith("%")
        );
        return nonEmptyParts
          .map((part, index) => {
            if (index === numIndex) {
              return part + (index < nonEmptyParts.length - 1 ? SEPARATOR : "");
            }
            return part.trim();
          })
          .join("");
      }
    } else {
      // More than one number, return the original input
      return input;
    }
  } catch (error) {
    return input;
  }
}

const isNumber = (str) => {
  if (!str) return false;
  return !isNaN(parseFloat(str));
};

const getNumber = (str) => {
  if (!str) return 0;
  if (str.includes("%")) return parseFloat(str) + "%";
  return parseFloat(str).toString();
};

const cleanTableCellTextToCopy2 = (input) => {
  try {
    if (!input) return "";
    input = input.trim();
    if (input === "-") {
      return "0";
    }

    let cleanedInput = input.replace(/[$,]/g, "");
    cleanedInput = cleanedInput.replace(
      /\((\d+(?:\.\d+)?)\)/g,
      (match, number) => `-${number}`
    );

    const words = cleanedInput.split(" ");

    if (words.length === 1) {
      if (isNumber(words[0])) {
        return getNumber(words[0]);
      } else {
        return input;
      }
    } else {
      if (isNumber(words[0])) {
        const remainingString = words.slice(1).join(" ");

        if (remainingString.match(/\d/g)) {
          return input;
        }
        return getNumber(words[0]) + SEPARATOR + words.slice(1).join(" ");
      } else {
        return input;
      }
    }

    return input;
  } catch (error) {
    return input;
  }
};

export default cleanTableCellTextToCopy2;
